module.exports = __webpack_public_path__ + "static/media/zoom_in.d4dea844.svg";